export class SubscribersGetResponse {

  public amount: number;
  public amountPerSearch: number;
  public list: Subscription[];
}
export class Subscription {
  public userId: number;
  public menuimNo: number;
  public name: string;
  public lastName: string;
  public companyName: string;
  public menuimCarNo: string;
  public menuimCarNo2: string;
  public insidePark: number;
  public menuimStartDate: string;
  public menuimEndDate: string;
  public isReservedPlace: boolean;
  
  public reservedParkID: number;
  public sitesList: Array<string>;
  public parkEntranceDate: string;
  public parkDescription: string;
  public parkNumber: number;
  public phone: string;
  public destinedPark: number;

    constructor(
      userId?: number,
      menuimNo?: number,
      name?: string,
      lastName?: string,
      companyName?: string,
      menuimCarNo?: string,
      menuimCarNo2?: string,
      insidePark?: number,
      menuimStartDate?: string,
      menuimEndDate?: string,
      isReservedPlace?: boolean,
      reservedParkID?:number,
      sitesList?: Array<string>,
      parkEntranceDate?: string,
      parkDescription?: string,
      parkNumber?: number,
      phone?: string,
      destinedPark?: number
    ) {
        this.userId = userId;
        this.menuimNo = menuimNo;
        this.name = name;
        this.lastName = lastName;
        this.companyName = companyName;
        this.menuimCarNo = menuimCarNo;
        this.menuimCarNo2 = menuimCarNo2;
        this.insidePark = insidePark;
        this.menuimStartDate = menuimStartDate;
        this.menuimEndDate = menuimEndDate;
        this.isReservedPlace = isReservedPlace;
        this.reservedParkID = reservedParkID;
        this.sitesList = sitesList;
        this.parkEntranceDate = parkEntranceDate;
        this.phone = phone;
        if (!this.phone) {
          this.phone = '';
        }
        this.parkDescription = parkDescription;
        this.parkNumber = parkNumber;
        this.destinedPark = destinedPark;
    }
}
